module.exports = __webpack_public_path__ + "img/presentacion.5d2ce569.png";